require('./lbaLatLngMap.scss');

const $inject = [];

const lbaLatLngMap = function () {
  return {
    restrict: 'A',
    controller: 'lbaLatLngMapCtrl',
    controllerAs: 'vm',
    bindToController: true,
    template: require('./lbaLatLngMap.html'),
    scope: {
      settings: '='
    }
  }
};

lbaLatLngMap.$inject = $inject;

export default lbaLatLngMap;



// WEBPACK FOOTER //
// ./src/components/lbaLatLngMap/lbaLatLngMapDir.js